module.exports = __webpack_public_path__ + "3fab8894c10311ded390f76e7128d168.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SEFI.svg
// module id = C6UR
// module chunks = 0